import type { PublicSlotKey } from '#packages/apilib';
import type { TextUploadToStageApi } from './textUploadToStageApi';

export const TextUploadToStageApiKey: PublicSlotKey<TextUploadToStageApi> = {
  name: 'TextUploadToStageApi',
  public: true,
};
